export default __webpack_public_path__ + "static/media/bl.d418d7c6.png";